import { Button, Card } from '@payaca/ambrosia';
import { FunctionComponent, type JSX } from 'react';
import { useIntercom } from 'react-use-intercom';

import AuthenticatedPageWrapper from '../pageWrappers/authenticatedPageWrapper/AuthenticatedPageWrapper';

import { useCreateBillingPortalSession } from '@/api/mutations/subscriptions/useCreateBillingPortalSession';

const ManageSubscriptionPage: FunctionComponent = (): JSX.Element => {
  const { show } = useIntercom();

  const billingPortalMutation = useCreateBillingPortalSession({
    onSuccess: (data) => {
      if (
        data.createBillingPortalSession.__typename ===
        'CreateBillingPortalSessionSuccess'
      ) {
        window.location.href = data.createBillingPortalSession.url;
      }
    },
  });

  const error =
    billingPortalMutation.data?.createBillingPortalSession.__typename ===
    'CreateBillingPortalSessionError'
      ? billingPortalMutation.data.createBillingPortalSession.message
      : billingPortalMutation.error
        ? 'Unable to open subscription portal. Please try again.'
        : null;

  const handleManageSubscription = () => {
    billingPortalMutation.mutate();
  };

  return (
    <AuthenticatedPageWrapper>
      <div className="typography:prose">
        <h1 className="px-8 py-4">Manage subscription</h1>
      </div>
      <div className="p-4 pt-0">
        <Card sizeVariant="lg">
          <Card.Body>
            <div className="flex flex-col items-center gap-y-4 py-8">
              <p className="text-gray-600 text-center max-w-[37.33rem]">
                Manage your subscription, update payment methods, view invoices,
                and more through our billing portal.
              </p>
              {error && <p className="text-red-600 text-sm">{error}</p>}
              <Button
                variant="solid"
                onClick={handleManageSubscription}
                isProcessing={billingPortalMutation.isPending}
              >
                Open Billing Portal
              </Button>
            </div>
            <div className="flex items-center justify-center gap-x-3 mt-6 border-t pt-6">
              <span className="text-gray-500">Need help?</span>
              <Button variant={'outline'} size={'sm'} onClick={show}>
                Get in touch
              </Button>
            </div>
          </Card.Body>
        </Card>
      </div>
    </AuthenticatedPageWrapper>
  );
};

export default ManageSubscriptionPage;
